import isEnabled from '../utils/isEnabled';
import { isXOrY, isX } from '../typeGuards/Channel';
import { isTypedFieldDef } from '../typeGuards/ChannelDef';
import expandLabelOverlapStrategy from './expandLabelOverlapStrategy';
import { continuousToContinuousScaleTypesSet } from '../parsers/scale/scaleCategories';

function isChannelDefWithAxisSupport(channelType, channelDef) {
  return isTypedFieldDef(channelDef) && isXOrY(channelType);
}

export default function completeAxisConfig(channelType, channelDef) {
  if (isChannelDefWithAxisSupport(channelType, channelDef) && isEnabled(channelDef.axis)) {
    const axis = channelDef.axis === true || typeof channelDef.axis === 'undefined' ? {} : channelDef.axis;
    const isXChannel = isX(channelType);
    const {
      format = channelDef.format,
      formatType = channelDef.formatType,
      formatInLocalTime = channelDef.formatInLocalTime,
      labelAngle = 0,
      labelFlush,
      labelOverlap,
      labelPadding = 4,
      orient = isXChannel ? 'bottom' : 'left',
      tickCount = 5,
      ticks = true,
      title = channelDef.title,
      titlePadding = 4
    } = axis;
    const output = { ...axis,
      format,
      formatType,
      labelAngle,
      labelFlush: typeof labelFlush === 'undefined' ? channelDef.scale && typeof channelDef.scale.type !== 'undefined' && continuousToContinuousScaleTypesSet.has(channelDef.scale.type) : labelFlush,
      labelOverlap: expandLabelOverlapStrategy(channelType, labelOverlap),
      labelPadding,
      orient,
      tickCount,
      ticks,
      title,
      titlePadding
    };

    if (typeof formatInLocalTime !== 'undefined') {
      output.formatInLocalTime = formatInLocalTime;
    }

    return output;
  }

  return false;
}